import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import * as actionTypes from './actionTypes';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: '/account',
    pluginName: 'BILLING',
    entityName: 'ACCOUNT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch billingAccount action creators
export const fetchBillingAccountInit = () => {
    return crudActions.fetchInit();
};
export const fetchBillingAccountStart = () => {
    return crudActions.fetchStart();
};
export const fetchBillingAccountSuccess = (fetchBillingAccountCount, listBillingAccountCount) => {
    return crudActions.fetchSuccess(fetchBillingAccountCount, listBillingAccountCount);
};
export const fetchBillingAccountFail = () => {
    return crudActions.fetchFail();
};
export const fetchBillingAccountCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBillingAccountStart());
        try {
            let countRes = await rest.post("account/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchBillingAccountSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchBillingAccountFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch billing accounts."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchBillingAccountFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch billing accounts."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchBillingAccount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBillingAccountStart());
        try {
            let listRes = await rest.post("account/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchBillingAccountSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchBillingAccountFail());
            return []
        } catch (error) {
            dispatch(fetchBillingAccountFail());
            return []
        }
    }
}

// Load billingAccount action creators
export const loadBillingAccountInit = () => {
    return crudActions.loadInit();
};
export const loadBillingAccountStart = () => {
    return crudActions.loadStart();
};
export const loadBillingAccountSuccess = loadedBillingAccount => {
    return crudActions.loadSuccess(loadedBillingAccount);
};
export const loadBillingAccountFail = error => {
    return crudActions.loadFail(error);
};
export const loadBillingAccount = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create billingAccount  action creators
export const createBillingAccountInit = () => {
    return crudActions.createInit();
};
export const createBillingAccountStart = () => {
    return crudActions.createStart();
};
export const createBillingAccountSuccess = createdBillingAccount => {
    return crudActions.createSuccess(createdBillingAccount);
};
export const createBillingAccountFail = error => {
    return crudActions.createFail(error);
};
export const createBillingAccount = billingAccount => {
    return async dispatch => {
        await crudActions.create(dispatch, billingAccount);
    };
};

// Edit billingAccount  action creators
export const editBillingAccountInit = () => {
    return crudActions.editInit();
};
export const editBillingAccountStart = () => {
    return crudActions.editStart();
};
export const editBillingAccountSuccess = editedBillingAccount => {
    return crudActions.editSuccess(editedBillingAccount);
};
export const editBillingAccountFail = error => {
    return crudActions.editFail(error);
};

export const editBillingAccount = account => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(editBillingAccountStart());
            let res = await rest.post('/account/update', account);
            if (res.data && res.data.succeeded) {
                dispatch(editBillingAccountSuccess({
                    updated: res.data.result.data
                }));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            }
            else {
                dispatch(editBillingAccountFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return {};
            }
        }
        catch (error) {
            dispatch(editBillingAccountFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};



// Bulk delete billingAccount action creators
export const bulkDeleteBillingAccountsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteBillingAccountsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteBillingAccountsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteBillingAccountsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteBillingAccounts = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteBillingAccountsStart());
        try {
            let res = await rest.post('/account/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteBillingAccountsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted billing accounts.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteBillingAccountsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete billing accounts."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete billing accounts."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteBillingAccountsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete billingAccount  action creators
export const deleteBillingAccountInit = () => {
    return crudActions.deleteInit();
};
export const deleteBillingAccountStart = () => {
    return crudActions.deleteStart();
};
export const deleteBillingAccountSuccess = deletedBillingAccount => {
    return crudActions.deleteSuccess(deletedBillingAccount);
};
export const deleteBillingAccountFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteBillingAccount = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// list account action licenses
export const actionLicensesStart = () => {
    return {
        type: actionTypes.BILLING_ACTION_LICENSE_LIST_START,
        loading: true
    };
};
export const actionLicensesSuccess = actionLicenses => {
    return {
        type: actionTypes.BILLING_ACTION_LICENSE_LIST_START_SUCCESS,
        loading: false,
        actionLicenses: actionLicenses
    };
};
export const actionLicensesFail = () => {
    return {
        type: actionTypes.BILLING_ACTION_LICENSE_LIST_FAIL,
        loading: false
    };
};

// list account software licenses
export const softwareLicensesStart = () => {
    return {
        type: actionTypes.BILLING_SOFTWARE_LICENSE_LIST_START,
        loading: true
    };
};
export const softwareLicensesSuccess = softwareLicenses => {
    return {
        type: actionTypes.BILLING_SOFTWARE_LICENSE_LIST_SUCCESS,
        loading: false,
        softwareLicenses: softwareLicenses
    };
};
export const softwareLicensesFail = () => {
    return {
        type: actionTypes.BILLING_SOFTWARE_LICENSE_LIST_FAIL,
        loading: false
    };
};
// create account software licenses
export const softwareLicenseCreateStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_CREATE_START,
        creating: true
    };
};
export const softwareLicenseCreateSuccess = softwareLicense => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_CREATE_SUCCESS,
        creating: false,
        created: softwareLicense
    };
};
export const softwareLicenseCreateFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_CREATE_FAIL,
        creating: false
    };
};

// delete account software licenses
export const softwareLicenseDeleteStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_DELETE_START,
        deleting: true
    };
};
export const softwareLicenseDeleteSuccess = softwareLicense => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_DELETE_SUCCESS,
        deleting: false,
        deleted: softwareLicense
    };
};
export const softwareLicenseDeleteFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_DELETE_FAIL,
        deleting: false
    };
};

// load account software licenses
export const softwareLicenseLoadStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_LOAD_START
    };
};
export const softwareLicenseLoadSuccess = softwareLicense => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_LOAD_SUCCESS,
        loaded: softwareLicense
    };
};
export const softwareLicenseLoadFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_LOAD_FAIL
    };
};

// update account software licenses
export const softwareLicenseUpdateStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_UPDATE_START,
        updating: true
    };
};
export const softwareLicenseUpdateSuccess = softwareLicense => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_UPDATE_SUCCESS,
        updated: softwareLicense,
        updating: false
    };
};
export const softwareLicenseUpdateFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_SOFTWARE_LICENSE_UPDATE_FAIL,
        updating: false
    };
};

// list account plans
export const accountPlansListStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PLANS_LIST_START,
        loading: true
    };
};
export const accountPlansListSuccess = accountPlans => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PLANS_LIST_SUCCESS,
        loading: false,
        accountPlans: accountPlans
    };
};
export const accountPlansListFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PLANS_LIST_FAIL,
        loading: false
    };
};

// list prepaids
export const prepaidListStart = () => {
    return {
        type: actionTypes.BILLING_PREPAID_LIST_START,
        loading: true
    };
};
export const prepaidListSuccess = prepaidList => {
    return {
        type: actionTypes.BILLING_PREPAID_LIST_SUCCESS,
        loading: false,
        prepaids: prepaidList
    };
};
export const prepaidListFail = () => {
    return {
        type: actionTypes.BILLING_PREPAID_LIST_FAIL,
        loading: false
    };
};
// create prepaid plan
export const prepaidCreateStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_CREATE_START,
        creating: true
    };
};
export const prepaidCreateSuccess = prepaid => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_CREATE_SUCCESS,
        creating: false,
        created: prepaid
    };
};
export const prepaidCreateFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_CREATE_FAIL,
        creating: false
    };
};

// Bulk delete prepaid plans action creators
export const bulkDeletePrepaidPlansInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeletePrepaidPlansStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeletePrepaidPlansSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeletePrepaidPlansFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeletePrepaidPlans = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeletePrepaidPlansStart());
        try {
            let res = await rest.post('billing/pre-paid/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeletePrepaidPlansSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted prepaid plans.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeletePrepaidPlansFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete prepaid plans."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete prepaid plans."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeletePrepaidPlansFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// load prepaid plan
export const prepaidLoadStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_LOAD_START
    };
};
export const prepaidLoadSuccess = prepaid => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_LOAD_SUCCESS,
        loaded: prepaid
    };
};
export const prepaidLoadFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_LOAD_FAIL
    };
};

// update prepaid plan
export const prepaidUpdateStart = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_UPDATE_START,
        updating: true
    };
};
export const prepaidUpdateSuccess = prepaid => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_UPDATE_SUCCESS,
        updated: prepaid,
        updating: false
    };
};
export const prepaidUpdateFail = () => {
    return {
        type: actionTypes.BILLING_ACCOUNT_PREPAID_UPDATE_FAIL,
        updating: false
    };
};

export const listCustomers = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/list', { listAll: true, ...params }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return { data: 0, canceled: true };
            }
            if (res.data && res.data.succeeded) {
                const customers = [];
                for (var customer of res.data.result.data) {
                    const Address = typeof customer.Address === 'string' ? JSON.parse(customer.Address) : customer.Address;
                    customers.push({
                        value: customer.CustomerID,
                        displayValue: customer.Name,
                        City: Address?.City,
                        Country: Address?.Country,
                        State: Address?.State,
                        AddressLine1: Address?.AddressLine1,
                        AddressLine2: Address?.AddressLine2
                    });
                }
                return customers;
            } else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
};

export const listUsers = (id, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/users/list', { listAll: true, ...id, Status: 1, Deleted: false }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const users = [];
                for (var user of res.data.result.data) {
                    users.push({
                        value: user.UserID,
                        displayValue: `${user.FirstName} ${user.LastName} (${user.Username})`
                    });
                }
                return users;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];

        }
    };
};

export const listLicensePrototypes = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/license-prototype/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const licensePrototypes = [];
                for (var licensePrototype of res.data.result.data) {
                    licensePrototypes.push({
                        value: licensePrototype.LicensePrototypeID,
                        displayValue: licensePrototype.Name
                    });
                }
                return licensePrototypes;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const listPlans = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/plan/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const plans = [];
                for (var plan of res.data.result.data) {
                    if (!['active', 'prepared'].includes(plan.Status)) {
                        continue;
                    }
                    plans.push({ value: plan.PlanID, label: plan.Name });
                }
                return plans;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        }
        catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const onAccountPlansList = billingAccount => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(accountPlansListStart());
            let res = await rest.post('/account/list-plans', billingAccount);
            if (res.data && res.data.succeeded) {
                dispatch(accountPlansListSuccess({
                    list: res.data.result.data,
                    count: -1
                }));
                return { data: res.data.result.data, count: 0 }
            }
            else {
                dispatch(accountPlansListFail());

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            dispatch(accountPlansListFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const fetchSoftwareLicensesCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(softwareLicensesStart());
        try {
            let countRes = await rest.post("/software-license/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(softwareLicensesSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(softwareLicensesFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch software licenses."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(softwareLicensesFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch software licenses."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchSoftwareLicenses = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(softwareLicensesStart());
        try {
            let listRes = await rest.post("/software-license/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(softwareLicensesSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(softwareLicensesFail());
            return []
        } catch (error) {
            dispatch(softwareLicensesFail());
            return []
        }
    }
}

// Bulk delete software license action creators
export const bulkDeleteSoftwareLicenseInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteSoftwareLicenseStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteSoftwareLicenseSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteSoftwareLicenseFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteSoftwareLicense = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteSoftwareLicenseStart());
        try {
            let res = await rest.post('/software-license/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteSoftwareLicenseSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted software licenses.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteSoftwareLicenseFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete software licenses."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete software licenses."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteSoftwareLicenseFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const onUpdateSoftwareLicense = softwareLicense => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(softwareLicenseUpdateStart());
            let res = await rest.post('software-license/update', softwareLicense);
            if (res.data && res.data.succeeded) {
                dispatch(softwareLicenseUpdateSuccess({
                    updated: res.data.result.data
                }));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            }
            else {
                dispatch(softwareLicenseUpdateFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return {};
            }
        }
        catch (error) {
            dispatch(softwareLicenseUpdateFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const onFetchSoftwareLicense = softwareLicense => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(softwareLicenseLoadStart());
            let res = await rest.post('/software-license/load', softwareLicense);
            if (res.data && res.data.succeeded) {
                dispatch(softwareLicenseLoadSuccess(res.data.result.data));
                return res.data.result.data;
            }
            else {
                dispatch(softwareLicenseLoadFail());

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return {};
            }

        } catch (error) {
            dispatch(softwareLicenseLoadFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const onDeleteSoftwareLicense = softwareLicense => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(softwareLicenseDeleteStart());
            let res = await rest.post('/license/delete', softwareLicense);
            if (res.data && res.data.succeeded) {
                dispatch(softwareLicenseDeleteSuccess({
                    softwareLicense: res.data.result.data
                }));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            } else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(softwareLicenseDeleteFail());
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const onSoftwareLicenseCreate = softwareLicense => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(softwareLicenseCreateStart());
            let res = await rest.post('/software-license/create', softwareLicense);
            if (res.data && res.data.succeeded) {
                dispatch(softwareLicenseCreateSuccess({
                    softwareLicense: res.data.result.data
                }));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(softwareLicenseCreateFail());
                return {};
            }

        } catch (error) {
            dispatch(softwareLicenseCreateFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const fetchActionLicensesCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(actionLicensesStart());
        try {
            let countRes = await rest.post("/action-license/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(actionLicensesSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(actionLicensesFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch action licenses."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(actionLicensesFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch action licenses."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchActionLicenses = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(actionLicensesStart());
        try {
            let listRes = await rest.post("/action-license/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(actionLicensesSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(actionLicensesFail());
            return []
        } catch (error) {
            dispatch(actionLicensesFail());
            return []
        }
    }
}

export const releaseLicense = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/action-license/release", filterData);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data
            }
            snackActions.snackBar({
                message: `${res.data ? res.data.message : res.message}`,
                options: {
                    variant: 'warning'
                }
            })
            return false
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false
        }
    }
}
export const bulkReleaseLicense = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/action-license/bulk-release", filterData);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data
            }
            snackActions.snackBar({
                message: `${res.data ? res.data.message : res.message}`,
                options: {
                    variant: 'warning'
                }
            })
            return false
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false
        }
    }
}

export const assignPlans = data => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let res = await rest.post('/account/assign-plan', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }


        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const removePlans = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editBillingAccountInit());
        try {
            dispatch(editBillingAccountStart());
            let res = await rest.post('/account/remove-plans', data);
            if (res.data && res.data.succeeded) {
                // dispatch(editBillingAccountSuccess({}));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })

                return [];
            }
        } catch (error) {
            dispatch(editBillingAccountFail(error));

            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            })

            return [];
        }
    };
};
/*****************************************************
 *               PREPAID PLAN ACTIONS                *
 *****************************************************/
export const fetchPrePaidPlansCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(prepaidListStart());
        try {
            let countRes = await rest.post("/billing/pre-paid/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(prepaidListSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(prepaidListFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch prepaid plans."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(prepaidListFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch prepaid plans."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchPrePaidPlans = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(prepaidListStart());
        try {
            let listRes = await rest.post("/billing/pre-paid/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(prepaidListSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(prepaidListFail());
            return []
        } catch (error) {
            dispatch(prepaidListFail());
            return []
        }
    }
}

export const onUpdatePrePaid = prepaid => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(prepaidUpdateStart());
            let res = await rest.post('/billing/pre-paid/save', prepaid);
            if (res.data && res.data.succeeded) {
                dispatch(prepaidUpdateSuccess({
                    updated: res.data.result.data
                }));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(prepaidUpdateFail());

                return {};
            }
        } catch (error) {
            dispatch(prepaidUpdateFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const onFetchPrePaid = prepaid => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(prepaidLoadStart());
            let res = await rest.post('/billing/pre-paid/load', prepaid);
            if (res.data && res.data.succeeded) {
                dispatch(prepaidLoadSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(prepaidLoadFail());

                return {};
            }
        } catch (error) {
            dispatch(prepaidLoadFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const onPrepaidPlanCreate = prepaid => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(prepaidCreateStart());
            let res = await rest.post('/billing/pre-paid/create', prepaid);
            if (res.data && res.data.succeeded) {
                dispatch(prepaidCreateSuccess({
                    prepaid: res.data.result.data
                }));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(prepaidCreateFail());

                return {};
            }
        } catch (error) {
            dispatch(prepaidCreateFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

/*****************************************************
 *            Delivery notes                *
 *****************************************************/

// list prepaids
export const deliveryNotesListStart = () => {
    return {
        type: actionTypes.BILLING_PREPAID_LIST_START,
        loading: true
    };
};
export const deliveryNotesListSuccess = deliveryNotesList => {
    return {
        type: actionTypes.BILLING_PREPAID_LIST_SUCCESS,
        loading: false,
        deliveryNotes: deliveryNotesList
    };
};
export const deliveryNotesListFail = () => {
    return {
        type: actionTypes.BILLING_PREPAID_LIST_FAIL,
        loading: false
    };
};
export const onListDeliveryNotes = deliveryNotesPlan => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(deliveryNotesListStart());
            let countRes = await rest.post('/billing/delivery_notes/count', deliveryNotesPlan);
            let res = await rest.post('/billing/delivery_notes/list', deliveryNotesPlan);
            if (res.data && res.data.succeeded && countRes.data && countRes.data.succeeded) {
                dispatch(deliveryNotesListSuccess({
                    list: res.data.result.data,
                    count: countRes.data.result.data
                }));
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                dispatch(deliveryNotesListFail());

                return {};
            }
        } catch (error) {
            dispatch(deliveryNotesListFail());
            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot create binary image'}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};


export const cleanState = () => {
    return ({
        type: 'CLEAN_STATE_ACCOUNT',
    });
}
